import { SportCodes } from "@prestosports/prestostats-core/Common";
import flagFootballConfiguration from "../../football/config/flag-football-configuration";

// sportId → Configuration form extension ({sport}-configuration.js modules).
// Sports absent here render the plain generic settings form.
const SPORT_CONFIGURATIONS = {
	[SportCodes.FlagFootball]: flagFootballConfiguration
};

export const getSportConfiguration = (sportId) => {
	return SPORT_CONFIGURATIONS[sportId];
};

export default SPORT_CONFIGURATIONS;
